module.exports = __webpack_public_path__ + "static/media/gift05_zhChs.240f8c9e.png";